import React, {Component} from 'react';
import PropTypes from "prop-types";
import StaticFunctions from "../../utils/StaticFunctions";
import Api from "../../utils/Api";
import Timeformat from "../../utils/Timeformat";
import Tacho from "./Tacho";
import ProgressBar from "./ProgressBar";
import './machines.css';
import MachineStates from "../../utils/MachineStates";
import DesignPreviewContainer from "../../utils/DesignPreviewContainer";

class MachineMedium extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        machine: PropTypes.object.isRequired,
        onClick: PropTypes.func.isRequired
    };

    static defaultProps = {
        stitchesAndThreadbreaks: [],
    };

    static getProgress(status, stitches, patternStitches) {

        let progressValue = Math.floor((100 / patternStitches) * stitches);

        switch (status) {
            case 1001:
                progressValue = 0;
                break;

            case 1012:
                progressValue = 100;
                break;
        }

        if (progressValue < 0) progressValue = 0;
        if (progressValue > 100) progressValue = 100;

        return progressValue;

    }

    constructor(props) {

        super(props);

        this.api = new Api();

        this.translate = this.props.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);

        this.clicked = this.clicked.bind(this);

    }

    clicked() {

        if (this.props.onClick) this.props.onClick(this.props.machine);

    }

    getLocationById(locationId) {

        let location = '-';
        let locations = this.props.baseData.locations;

        locations.find((locationData) => {
            if (parseInt(locationData.id) === parseInt(locationId)) location = locationData.name;
        });

        return location;

    }

    getRemainingTime() {

        const machine = this.props.machine;

        const patternStitches = machine.pattern_stitchcounter;
        const stitches = (machine.status === 1012) ? machine.pattern_stitchcounter : machine.pattern_stitchnumber;

        const rpm = this.props.baseData.companies.currentCompany.machine_rpm / 60;
        const remainingStitches = patternStitches - stitches;

        return (remainingStitches > 0) ? Math.round(remainingStitches / rpm) : 0;    //  Time in seconds.

    }

    getMachineOperator() {

        const machine = this.props.machine;

        let machineOperator = machine.id_operator;

        if (machine.operator_name) {
            machineOperator = machine.operator_name;
        } else if (machine.id_token) {
            machineOperator = machine.id_token;
        } else {
            machineOperator = '1@ZSK-' + this.props.machine.machine_id;
        }

        return machineOperator;

    }

    render() {

        const timezone = this.props.baseData.companies.currentCompany.timezone;

        const machine = this.props.machine;
        const machineId = machine.machine_id;
        const machineOperator = this.getMachineOperator();
        const machineLastTransmission = (machine.last_seen) ? Timeformat.fromUnix(machine.last_seen).getFormatedDate(this.timeFormats.datetime, timezone) : '-';

        const statusClass = MachineStates.getStatusType(machine.status);
        const statusColorCodes = MachineStates.getColorSetByStatus(statusClass);
        const classes = ['archivContainer', 'col-xs-12', 'col-sm-6', 'col-md-3', 'col-lg-3', 'machine', statusClass].join(' ');

        const patternStitches = machine.pattern_stitchcounter;
        const stitches = (machine.status === 1012) ? machine.pattern_stitchcounter : machine.pattern_stitchnumber;
        const progress = (machine.status !== 1001) ? MachineMedium.getProgress(machine.status, stitches, patternStitches) : 0;

        const stitchesLeft = patternStitches - stitches;
        const stitchesAndThreadbreaks = (this.props.stitchesAndThreadbreaks[machineId]) ? this.props.stitchesAndThreadbreaks[machineId] : {st: 0, tb: 0};

        const totalStitches = stitchesAndThreadbreaks.st;
        const totalThreadbreaks = stitchesAndThreadbreaks.tb;

        const remainingTime = (machine.status !== 1001) ? this.getRemainingTime() : null;
        const progressBar = <ProgressBar percentage={progress} status={statusClass}/>;

        return (
            <div className={classes}>
                <div onClick={this.clicked} style={{cursor: 'pointer'}}>
                    <div className="header" style={{backgroundColor: statusColorCodes.color2}}>
                        <h2>{machine.alias}</h2>

                        <i style={{backgroundColor: statusColorCodes.color1}}>ok</i>
                    </div>

                    <div className="content" style={{backgroundCOlor: statusColorCodes.color3}}>
                        <div className="clearfix">
                            <div className="machineBlock fll">
                                <div className="designRemainingTime">{StaticFunctions.convertSecondsToFormatedString(remainingTime, true)}</div>

                                {progressBar}
                            </div>

                            <div className="machineBlock flr">
                                <div className="designView">
                                    <DesignPreviewContainer
                                        baseData={this.props.baseData}
                                        designId={machine.pattern_number}
										designStitches={machine.pattern_stitchcounter}
                                    />
                                </div>

                                <div className="designName">{(machine.pattern_number) ? machine.pattern_number : '-'}</div>
                            </div>
                        </div>

                        <div className="machineSettings clearfix">
                            <div className="machineBlock fll">
                                <div className="machineRow">
                                    <div className="machineValue">{machine.machine_id}</div>
                                    <div className="machineLabel">{this.translate('id')}</div>
                                </div>

                                <div className="machineRow">
                                    <div className="machineValue">{this.getLocationById(machine.id_location)}</div>
                                    <div className="machineLabel">{this.translate('location')}</div>
                                </div>

                                <div className="machineRow">
                                    <div className="machineValue">{(machineOperator) ? machineOperator : '-'}</div>
                                    <div className="machineLabel">{this.translate('operator')}</div>
                                </div>

                                <div className="machineRow">
                                    <div className="machineValue">{machineLastTransmission}</div>
                                    <div className="machineLabel">{this.translate('lastTransmission')}</div>
                                </div>
                            </div>

                            <div className="machineBlock flr">
                                <div className="machineRow">
                                    <div className="machineValue">{(stitchesLeft > 0) ? StaticFunctions.formatedNumber(stitchesLeft) : 0}</div>
                                    <div className="machineLabel">{this.translate('remainingStitches')}</div>
                                </div>

                                <div className="machineRow">
                                    <div className="machineValue">{StaticFunctions.formatedNumber(stitches)} / {StaticFunctions.formatedNumber(patternStitches)}</div>
                                    <div className="machineLabel">{this.translate('stitches')} / {this.translate('totalStitches')}</div>
                                </div>

                                <div className="machineRow">
                                    <div className="machineValue">{StaticFunctions.formatedNumber(totalStitches)}</div>
                                    <div className="machineLabel">{this.translate('totalStitches')} ({this.translate('last').toLowerCase()} {this.translate('24h')})</div>
                                </div>

                                <div className="machineRow">
                                    <div className="machineValue">{StaticFunctions.formatedNumber(totalThreadbreaks)}</div>
                                    <div className="machineLabel">{this.translate('threadbreaks')} ({this.translate('last').toLowerCase()} {this.translate('24h')})</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

    }

}
/*

                        <div className="clearfix">
                            <div className="machineBlock tableGrid" style={{width: '100%'}}>
                                <Grid fluid>
                                    <Row>
                                        <Col xs={12} xl={12}>
                                            <Grid fluid>
                                                <Row>
                                                    <Col xs={12} lg={7} style={{paddingRight: 10, textAlign: 'right'}}>
                                                        ID {machine.machine_id}
                                                    </Col>

                                                    <Col xs={12} lg={5}>
                                                        {this.getLocationById(machine.id_location)}
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col xs={12} lg={7} style={{paddingRight: 10, textAlign: 'right'}}>
                                                        {this.translate('stitches')}/{this.translate('totalStitches')}
                                                    </Col>

                                                    <Col xs={12} lg={5}>
                                                        {machine.pattern_stitchnumber} / {machine.pattern_stitchcounter}
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col xs={12} lg={7} style={{paddingRight: 10, textAlign: 'right'}}>
                                                        {this.translate('remainingStitches')}
                                                    </Col>

                                                    <Col xs={12} lg={5}>
                                                        {(stitchesLeft > 0) ? stitchesLeft : 0}
                                                    </Col>
                                                </Row>

                                                <Row style={{marginTop: 10}}>
                                                    <Col xs={12} lg={7} style={{paddingRight: 10, textAlign: 'right'}}>
                                                        {this.translate('estimatedRemainingTime')}
                                                    </Col>

                                                    <Col xs={12} lg={5}>
                                                        {formatedRemainingTime}
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col xs={12} lg={7} style={{paddingRight: 10, textAlign: 'right'}}>
                                                        {this.translate('totalStitches')} ({this.translate('last').toLowerCase()} {this.translate('24h')})
                                                    </Col>

                                                    <Col xs={12} lg={5}>
                                                        {totalStitches}
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col xs={12} lg={7} style={{paddingRight: 10, textAlign: 'right'}}>
                                                        {this.translate('threadbreaks')} ({this.translate('last').toLowerCase()} {this.translate('24h')})
                                                    </Col>

                                                    <Col xs={12} lg={5}>
                                                        {totalThreadbreaks}
                                                    </Col>
                                                </Row>

                                                <Row style={{marginTop: 10}}>
                                                    <Col xs={12} lg={7} style={{paddingRight: 10, textAlign: 'right'}}>
                                                        {this.translate('operator')}
                                                    </Col>

                                                    <Col xs={12} lg={5}>
                                                        {(machineOperator) ? machineOperator : '-'}
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col xs={12} lg={7} style={{paddingRight: 10, textAlign: 'right'}}>
                                                        {this.translate('lastTransmission')}
                                                    </Col>

                                                    <Col xs={12} lg={5}>
                                                        {(machineLastTransmission) ? machineLastTransmission : '-'}
                                                    </Col>
                                                </Row>
                                            </Grid>
                                        </Col>
                                    </Row>
                                </Grid>
                            </div>
                        </div>
                    </div>
 */

/*
    <div className="clearfix">
        <div className="machineBlock" style={{width: '100%'}}>
            <table style={{width: '100%'}}>
                <tbody>
                    <tr>
                        <td className="text-right">ID {machine.machine_id}</td>
                        <td className="text-left">{this.getLocationById(machine.id_location)}</td>
                    </tr>
                    <tr>
                        <td className="text-right">{machine.pattern_stitchnumber} / {machine.pattern_stitchcounter}</td>
                        <td className="text-left">Stitches</td>
                    </tr>
                    <tr>
                        <td className="text-right">{(stitchesLeft > 0) ? stitchesLeft : 0}</td>
                        <td className="text-left">Remaining Stitches</td>
                    </tr>
                    <tr>
                        <td className="text-right">Estimated Remaining Time</td>
                        <td className="text-left">{formatedRemainingTime}</td>
                    </tr>
                    <tr>
                        <td className="text-right">{totalStitches}</td>
                        <td className="text-left">Total Stitches (last 24h)</td>
                    </tr>
                    <tr>
                        <td className="text-right">{totalThreadbreaks}</td>
                        <td className="text-left">Threadbreaks (last 24h)</td>
                    </tr>
                    <tr>
                        <td className="text-right">{Timeformat.fromUnix(machine.last_seen).getDateTime(this.props.baseData.companies.currentCompany.timezone)}</td>
                        <td className="text-left">Last Transmission</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
*/

export default MachineMedium;
